const urlPrefix = 'digital-learning'

const pages = {
  index: {
    'pt-br': `/hotmartacademy`,
    en: `/${urlPrefix}`,
    es: `/${urlPrefix}`,
    'es-es': `/${urlPrefix}`,
    'es-co': `/${urlPrefix}`,
    'es-mx': `/${urlPrefix}`,
  },
  'thank-you': {
    'es-co': `/${urlPrefix}/gracias`,
    'es-mx': `/${urlPrefix}/gracias`,
  },
}

export default pages
